import { render, staticRenderFns } from "./property-detail.vue?vue&type=template&id=23d01038&scoped=true&"
import script from "./property-detail.vue?vue&type=script&lang=ts&"
export * from "./property-detail.vue?vue&type=script&lang=ts&"
import style0 from "@/modules/AccountAsset/styles/property-detail-detail.scss?vue&type=style&index=0&id=23d01038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d01038",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
